module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/march-e3580ab8eeccf4b7f567de8172dfc4e5.png";